//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import { DEFAULT_DOMAIN } from '@/const/amo'
import coursesColors from '@/const/coursesColors'
import { mapGetters, mapState } from 'vuex'
import { ADVERTISING_CAMPAIGN_BRANCH_CODE } from '@/const/branch'
import eventBus from '@/utils/eventBus'
import FacultyMixin from '@/mixins/faculty.js'
import ElLink from '@/components/UI/el-link'
import CityBillet from '~/components/modals/CityBillet'
import 'vuescroll/dist/vuescroll.css'
const Entities = require('html-entities').AllHtmlEntities

export default {
  name: 'Header',
  components: {
    CityBillet,
    ElLink,
    VueScroll: () => import('vuescroll'),
  },
  mixins: [scroll, FacultyMixin],
  data() {
    return {
      scrollPosition: 0,
      isFixed: false,
      isOpen: false,
      isCoursesMenuActive: false,
      isCitiesMenuActive: false,
      domains: [],
      currentDomain: { title: 'Москва', siteUrl: DEFAULT_DOMAIN },
      coursesColors,
      scrollOptions: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
          onlyShowBarOnScroll: false,
          keepShow: true,
          background: '#21FAD3',
          size: '12px',
          specifyBorderRadius: '10px',
          minSize: 0.1,
        },
      },
      ws_url: this.$getTextMainSetting('ws_url'),
      tg_url: this.$getTextMainSetting('tg_url'),
      facultiesUrls: ['/math', '/coding'],
      isLangSelectorActive: false,
    }
  },
  computed: {
    ...mapGetters({
      courses: 'landings/courses',
      availableLanguageCodes: 'landings/availableLanguageCodes',
      currentLanguageCode: 'landings/currentLanguageCode',
    }),
    ...mapState(['landings', 'i18n']),
    currentDomainData() {
      return this.$getCurrentDomainData()
    },
    coursesCards() {
      const courses = this.$getCourses()
      const courseCards = this.$getBulletsMainSetting('_courseCards')
      const result = []
      for (const facultyLabel in courses) {
        result[facultyLabel] = []
        for (const courseIdx in courses[facultyLabel]) {
          if (
            courses[facultyLabel][courseIdx].isActive &&
            !this.facultiesUrls.includes(
              courses[facultyLabel][courseIdx].urlPath
            )
          ) {
            const foundCourseCard = courseCards.filter((courseCard) => {
              return courseCard.url === courses[facultyLabel][courseIdx].urlPath
            })
            if (foundCourseCard.length !== 0) {
              result[facultyLabel].push({
                id: courseIdx,
                urlPath: foundCourseCard[0].url,
                courseLabel: Entities.decode(foundCourseCard[0].title),
                isActive: true,
                order: +foundCourseCard[0].position,
              })
            }
          }
        }
      }
      result.coding.sort((courseA, courseB) => {
        return courseA.order - courseB.order
      })
      return result
    },
    faculties() {
      const data = this.$getCourses()
      const result = []
      for (const faculty in data) {
        for (const i in data[faculty]) {
          if (
            data[faculty][i].isActive &&
            this.facultiesUrls.includes(data[faculty][i].urlPath)
          ) {
            result.push(data[faculty][i])
          }
        }
      }
      return result
    },
    isCodingEnabled() {
      return this.isFacultyEnabled('coding') || false
    },
    options() {
      return this.domains
    },
    value() {
      return this.currentDomain
    },
    showCitiesDropdown() {
      return (
        this.currentDomainData.showInDropdown &&
        this.isRussianFranchise() &&
        !this.isAdvertisingCampaign()
      )
    },
  },
  mounted() {
    this.domains = this.$getDomains()
    this.currentDomain = this.$getCurrentDomainData()
    window.addEventListener(
      'scroll',
      this.throttle(this.changeHeaderStyles, 16),
      { passive: true }
    )
  },
  methods: {
    isRussianFranchise() {
      return this.$getTextMainSetting('isRussianFranchise')
    },
    activeClass(languageCode) {
      return this.isCurrentLanguage(languageCode)
        ? '_active disable-lang-chose'
        : ''
    },
    isCurrentLanguage(languageCode) {
      return languageCode === this.currentLanguageCode.substr(0, 2)
    },
    switchLanguage(languageCode) {
      if (this.isCurrentLanguage(languageCode)) {
        return
      }
      window.location.href = this.switchLocalePath(languageCode)
    },
    getLogo() {
      if (this.$i18n.locale === 'ru') {
        return require(`@/assets/img/redesign/creative/header-logo-ru.svg`)
      }
      return require(`@/assets/img/redesign/creative/header-logo-en.svg`)
    },
    isAdvertisingCampaign() {
      return (
        this.$getTextMainSetting('branchCode') ===
        ADVERTISING_CAMPAIGN_BRANCH_CODE
      )
    },
    changeCity(city) {
      window.location.host = city.siteUrl
    },
    openMenu(link) {
      if (link.length) {
        this.smoothVerticalScrolling(link)
      }
      this.isOpen = !this.isOpen
    },
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    changeHeaderStyles() {
      if (!this.isOpen) {
        window.scrollY >= document.querySelectorAll('.atm')[0].scrollHeight
          ? (this.isFixed = true)
          : (this.isFixed = false)
      }
    },

    throttle(callback, limit) {
      let tick = false
      return function () {
        if (!tick) {
          callback.call()
          tick = true
          setTimeout(function () {
            tick = false
          }, limit)
        }
      }
    },
    onPhoneNumberClick() {
      eventBus.$emit('click-phone-number')
    },
  },
}
